import React, { Component } from 'react';
import { connect } from 'react-redux';

import Speaker from './Speaker';


class SpeakerSection extends Component {

  createSpeakers() {
    const sectionData = this.props.sections.filter(section => (
      section.id === this.props.params.filter
    ));
    return sectionData[0].speakerViewList.map(speaker => (
      <Speaker key={speaker.speakerShortView.idStr} speakerData={speaker.speakerShortView}/>
    ));
  }

  render() {
    let section = null;
    if (this.props.sections.length > 0) {
      section = this.createSpeakers();
    }
    return (
      <div className='speakers__container speakers__container_users'>
        {section}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sections: state.speakers.sections
});

export default connect(mapStateToProps)(SpeakerSection);



// WEBPACK FOOTER //
// ./src/speakers-page/components/SpeakerSection.js